import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverDepthSizeM from './IconSolverDepth_size_m';

const props: CreateIconArguments = {
  l: IconSolverDepthSizeM,
  m: IconSolverDepthSizeM,
  s: IconSolverDepthSizeM,
  xs: IconSolverDepthSizeM,
  name: 'IconSolverDepth',
  renderType: { l: 'default', m: 'default', s: 'default', xs: 'default' },
  color: 'multiple',
};

export default props;
